import React from "react";

import { Switch, Route, withRouter } from "react-router-dom";

import Events from "./admin/events";
import Shifts from "./admin/shifts";

import "../../../styles/css/App.css";

function Router( { history, base } ) {
  
  return (
    <Switch>
      <Route path={`${base}/events/:eventId/shifts`}
        render={(props) => (
          <Shifts eventId={props.match.params.eventId}/>
      )}/>
      <Route path={`${base}/events`}>
        <Events />
      </Route>
    </Switch>
  );

}

export default withRouter(Router);
